<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <g :fill="color" fill-rule="nonzero">
        <g>
          <g>
            <path
              d="M97.913 0H2.033C.912 0 0 .91 0 2.034v95.879c0 1.123.91 2.034 2.034 2.034h95.879c1.123 0 2.033-.911 2.033-2.034V2.033C99.946.912 99.036 0 97.913 0zM4.068 95.879V4.068h91.81v13.556H10.99c-1.123 0-2.034.91-2.034 2.034 0 1.124.911 2.034 2.034 2.034H95.88V95.88H4.068z"
              transform="translate(-748 -318) translate(254 212) translate(494 106)"
            />
            <path
              d="M10.82 12.878c.536 0 1.062-.217 1.441-.593.376-.38.594-.902.594-1.437 0-.536-.218-1.061-.594-1.44-.38-.377-.905-.594-1.44-.594-.533 0-1.058.217-1.438.593-.376.38-.593.905-.593 1.44 0 .536.217 1.058.593 1.438.38.376.902.593 1.438.593zM17.6 12.882c.536 0 1.061-.217 1.438-.597.379-.38.596-.905.596-1.44 0-.533-.217-1.058-.596-1.438-.377-.38-.902-.596-1.438-.596-.535 0-1.06.216-1.437.596-.38.38-.597.905-.597 1.437 0 .536.217 1.061.597 1.441.377.38.902.597 1.437.597zM24.377 12.878c.535 0 1.061-.217 1.44-.593.38-.38.597-.905.597-1.44 0-.533-.217-1.058-.596-1.438-.38-.376-.906-.593-1.441-.593-.536 0-1.058.217-1.437.593-.377.38-.594.905-.594 1.437 0 .536.217 1.061.594 1.441.38.376.901.593 1.437.593zM83.555 55.416c-1.027-.453-2.228.012-2.682 1.04-5.407 12.25-17.535 20.164-30.9 20.164-13.062 0-24.946-7.562-30.524-19.343 5.578-11.781 17.462-19.344 30.525-19.344 9.471 0 18.566 4.023 24.953 11.038.755.83 2.042.89 2.873.134.83-.756.89-2.043.135-2.873-7.156-7.86-17.348-12.366-27.961-12.366-14.975 0-28.565 8.867-34.622 22.59-.23.523-.23 1.12 0 1.643C21.41 71.82 35 80.689 49.974 80.689c14.974 0 28.564-8.867 34.62-22.59.454-1.028-.011-2.23-1.039-2.683z"
              transform="translate(-748 -318) translate(254 212) translate(494 106)"
            />
            <path
              d="M35.78 57.277c0 7.826 6.367 14.192 14.193 14.192s14.193-6.366 14.193-14.192c0-7.826-6.367-14.193-14.193-14.193s-14.192 6.367-14.192 14.193zm24.318 0c0 5.583-4.541 10.125-10.124 10.125S39.849 62.86 39.849 57.277s4.542-10.125 10.125-10.125 10.124 4.542 10.124 10.125z"
              transform="translate(-748 -318) translate(254 212) translate(494 106)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
